import React, { useState } from 'react';
import SkillDetailModal from './SkillDetailModal';
import './SkillMap.css';

const CATEGORY_LABELS = { quantitative: 'Quantitative', logical: 'Logical', verbal: 'Verbal' };
const CATEGORY_ORDER = ['quantitative', 'logical', 'verbal'];

const STATE_LABEL = {
  mastered: 'Mastered', strong: 'Strong', improving: 'Improving',
  needs_attention: 'Needs Attention', declining: 'Declining', insufficient_data: 'Building Evidence',
};

// A progression WORLD, not a corporate flowchart — but on mobile that means a
// vertical, card-based list grouped by category (docs/UI_UX_ARCHITECTURE.md
// Phase 3 addendum), not a giant pannable node graph with tiny tap targets.
// `topics` is topicIntelligenceService's own output, used verbatim — no
// topic ever gets a numeric "Level N": that concept doesn't exist in the
// data model, and inventing one would violate the no-fabrication rule. The
// honest substitute is the real state label + real accuracy percentage.
const SkillMap = ({ topics }) => {
  const [selected, setSelected] = useState(null);

  const byCategory = CATEGORY_ORDER.map(cat => ({
    key: cat,
    label: CATEGORY_LABELS[cat],
    topics: topics.filter(t => t.category === cat),
  })).filter(g => g.topics.length > 0);

  if (byCategory.length === 0) {
    return (
      <div className="z-card skillmap-empty">
        Take a few questions and your Skill Map will start filling in here.
      </div>
    );
  }

  return (
    <div className="skillmap-root">
      {byCategory.map(group => (
        <div key={group.key} className="skillmap-category">
          <h4 className="skillmap-category-title">{group.label}</h4>
          <div className="skillmap-node-list">
            {group.topics.map(t => (
              <button
                key={t.topic_id}
                type="button"
                className={`skillmap-node skillmap-node--${t.state}`}
                onClick={() => setSelected(t)}
              >
                <span className="skillmap-node-name">{t.topic_name}</span>
                <span className="skillmap-node-state">{STATE_LABEL[t.state]}</span>
                {t.state !== 'insufficient_data' && (
                  <span className="skillmap-node-pct">{Math.round(t.evidence.accuracy_confidence_adjusted_pct)}%</span>
                )}
              </button>
            ))}
          </div>
        </div>
      ))}

      {selected && <SkillDetailModal topic={selected} onClose={() => setSelected(null)} />}
    </div>
  );
};

export default SkillMap;
